import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { Nav, Collapse, Image } from "react-bootstrap";
import { Placeholder } from "react-bootstrap";
import logo from "../../../images/logo.png";
import "./_navbar.scss";
import * as Cookies from "es-cookie";
import StudentAttendanceImg from "../../../images/Studnet attendancenew.png";
import HostelAtnImp from "../../../images/Hostel attendancenew.png";
import EmpAttendanceImg from "../../../images/Employee attendancenew.png";
import EmpAttendanceReportImg from "../../../images/employee attendance reportnew.png";
import ExamMarkUploadImg from "../../../images/Exam mark uploadnew.png";
import OfflineExamReportImg from "../../../images/offline exam reportnew.png";
import AdmissionFormImg from "../../../images/Admission formnew.png";
import EnrolledStudentsImg from "../../../images/enrolled studentsnew.png";
import EnquiryLinksImg from "../../../images/Enquiry linksnew.png";
import LeadManagementImg from "../../../images/Lead managementnew.png";
import DiaryImg from "../../../images/students diarynew.png";
import AssignmentsImg from "../../../images/Student assignmentnew.png";
import ExamReportsImg from "../../../images/Exam reportsnew.png";
import PermissionsImg from "../../../images/Student permissionnew.png";
import GatePassImg from "../../../images/gate passnew.png";
import NotifyParentsImg from "../../../images/Notify parentsnew.png";
import LecturerTimetableImg from "../../../images/Lecturer timetablenew.png";
import MaterialCreationImg from "../../../images/Material creationnew.png";
import ExamCreationImg from "../../../images/exam creationnew.png";
import ManageExamsImg from "../../../images/exam managemntnew.png";
import QuizCreationImg from "../../../images/Quiz creationnew.png";
import NotifyStudentsImg from "../../../images/Notify studentsnew.png";
import ExamCreation from "../../../images/exam creation.svg";
import ExamManagement from "../../../images/exam management.svg";
import StudentProfile from "../../../images/student profile.svg";
import gifimg from "../../../images/new-gif-icon.png";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import college_logo from "../../../images/dinesh_publications.gif";

import logoBlue from "../../../images/logo-blue.png";
import logoWhite from "../../../images/logo-white.png";
import vignanShortLogo from "../../../images/vignan_short_logo.png";

const SCROLL_KEY = "sidebarScrollTop";

// ─────────────────────────────────────────────────────────────────────────────
// Sidebar visibility, derived from the user's role permissions.
// ─────────────────────────────────────────────────────────────────────────────
//
// Every menu gate below reads `moduleRestrictions.<key> == false` ("false" means
// visible — the app's long-standing inverted convention). Rather than rewrite ~90
// gates, we change what feeds them: the map is now BUILT from roleModuleAccess,
// so a module appears if and only if the backend granted is_view on it.
//
// Nothing here names a module. Add a module in the backend, grant is_view, and it
// shows up; revoke it and it disappears. Parent menus and section headers already
// gate on "any child visible", so they hide automatically when every child does.

// The backend is inconsistent about booleans: is_view comes back as 1, "1", or true
// depending on the resolver. Normalise once.
const isGranted = (v) => v === 1 || v === "1" || v === true || v === "true";

const readJSON = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    if (raw && raw !== "" && raw !== "undefined") return JSON.parse(raw) || fallback;
  } catch (e) {
    // A corrupt localStorage value must never white-screen the whole app.
    console.error(`[sidebar] ${key} is not valid JSON — ignoring`, e);
  }
  return fallback;
};

// Institute admins / management (userlevel 1 & 2) have no role rows — their menu is
// the college's enabled module list, which login already wrote to moduleRestrictions.
const isFullAccess = () => ["1", "2"].includes(String(Cookies.get("userlevel") || ""));

// Returns the { module_key: false } map the gates below expect.
// `false` = visible. Any key NOT in the map is hidden (the gates test `!= undefined`).
export function buildModuleVisibility() {
  if (isFullAccess()) {
    // Admin: keep the existing institute-level list untouched.
    return readJSON("moduleRestrictions", {});
  }

  const roleAccess = readJSON("roleModuleAccess", []);

  // No role rows at all — the role isn't configured yet. Fall back to whatever login
  // stored, rather than blanking the sidebar on a data glitch.
  if (!Array.isArray(roleAccess) || roleAccess.length === 0) {
    return readJSON("moduleRestrictions", {});
  }

  const visibility = {};
  roleAccess.forEach((row) => {
    // Gates key off module_key ("Student_Doubts"), not the human-readable
    // module_name ("Doubts"). Fall back to module_name only when module_key is absent.
    const key = row.module_key || row.module_name;
    if (!key) return;

    // A module may have several rows (one per sub-module). It is visible if ANY row
    // grants view — otherwise granting a single sub-module would hide its parent.
    if (isGranted(row.is_view)) visibility[key] = false; // false = visible
    else if (visibility[key] === undefined) visibility[key] = true; // hidden (so far)
  });

  return visibility;
}

// True when the role can see nothing at all — used to show an Access Denied message
// instead of an empty sidebar the user can't act on.
export function hasNoAccessibleModules() {
  if (isFullAccess()) return false;
  const visibility = buildModuleVisibility();
  return !Object.values(visibility).some((hidden) => hidden === false);
}

function getActiveKeyFromPath(pathname) {
  const p = pathname;
  if (p.startsWith("/library")) return 15;
  if (
    p.startsWith("/questions/") ||
    p === "/quiz_section" ||
    p === "/exam_made_easy" ||
    p.startsWith("/exam_made_easy/") ||
    p === "/ExamReport_tabs" ||
    p.startsWith("/settings/exam-paper-pdf") ||
    p.startsWith("/settings/PDFQuestions")
  )
    return 7;
  if (p.startsWith("/offline_exams/")) return 8;
  if (
    p === "/student/attendance" ||
    p === "/student/attendance-report" ||
    p === "/attendance-regularization" ||
    p === "/Employee_Attendance" ||
    p === "/Employee_Attendance_Report" ||
    p === "/hostel-attendance" ||
    p === "/hostel/attendance-report"
  )
    return 3;
  if (
    p === "/admissions-dashboard" ||
    p === "/student-admission" ||
    p === "/student-admission-list" ||
    p === "/admission_form" ||
    p === "/enquiry-links" ||
    p === "/lead-management-home" ||
    p.startsWith("/lead-management") ||
    p.startsWith("/admission-forms")
  )
    return 4;
  if (p === "/student-diary" || p === "/notice" || p.startsWith("/assignment"))
    return 5;
  if (p === "/inst_revision_material" || p === "/material-assigning") return 9;
  if (p === "/settings/students" || p === "/settings/non-academic-students")
    return 10;
  if (p === "/Parent_Notification" || p === "/settings/notify-students")
    return 11;
  if (p === "/student-permission" || p === "/Student_Gate_Pass") return 12;
  if (p.startsWith("/hr-management")) return 20;
  if (p.startsWith("/settings/")) return 2;
  return 0;
}

class SideNavbar extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
    const activeKey = getActiveKeyFromPath(props.history.location.pathname);
    this.state = {
      rizeeLogo: window.location.hostname === "college.rizee.in",
      openSections: activeKey > 0 ? { [activeKey]: true } : {},
    };
  }

  getSidebarEl = () => document.getElementById("sidebar");
  isPinnedOpen = () => {
    const w = this.getSidebarEl()?.closest(".wrapper");
    return w ? w.classList.contains("sidebar-enable") : false;
  };

  // Save scroll on every scroll event — survives page navigation via sessionStorage
  handleScrollTrack = () => {
    if (this.scrollRef.current) {
      sessionStorage.setItem(SCROLL_KEY, this.scrollRef.current.scrollTop);
    }
  };

  handleSidebarEnter = () => {
    if (this.isPinnedOpen()) return;
    const el = this.getSidebarEl();
    if (el) el.classList.add("sidebar-expanded");

    const saved = parseInt(sessionStorage.getItem(SCROLL_KEY) || "0", 10);
    requestAnimationFrame(() => {
      if (this.scrollRef.current) {
        this.scrollRef.current.scrollTop = saved;
      }
    });
  };

  handleSidebarLeave = () => {
    if (this.isPinnedOpen()) return;
    // Save BEFORE removing class (layout still expanded, scrollTop still valid)
    if (this.scrollRef.current) {
      sessionStorage.setItem(SCROLL_KEY, this.scrollRef.current.scrollTop);
    }
    const el = this.getSidebarEl();
    if (el) el.classList.remove("sidebar-expanded");
  };
  getAccordianActive = () =>
    getActiveKeyFromPath(this.props.history.location.pathname);

  getActiveClass = (link) => {
    if (link === this.props.history.location.pathname)
      return "collapse-item active";
    else if (
      (this.props.history.location.pathname ===
        "/questions/create-question-paper/own-question-paper/college-exam" ||
        this.props.history.location.pathname.startsWith(
          "/exam_made_easy/draft_question_view",
        )) &&
      link === "/exam_made_easy"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname.startsWith(
        "/settings/PDFQuestions",
      ) &&
      link === "/settings/exam-paper-pdf/upload"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/settings/promote-students/promote-class" &&
      link === "/settings/promote-students"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/settings/promote-students/promote-exit-class" &&
      link === "/settings/promote-students"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/question-pattern/create-question-pattern" &&
      link === "/questions/question-pattern"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/own-question-paper" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      (this.props.history.location.pathname.startsWith(
        "/questions/manage-question-paper"
      ) ||
        this.props.history.location.pathname ===
        "/questions/proctoring-students") &&
      link === "/questions/manage-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/adaptive-question-paper" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/create-custom-question-paper" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/create-custom-question-paper/create-custom-summery" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/our-questions/manage-our-question-paper" &&
      link === "/questions/our-questions"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/error-question" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/un-answered" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/old-public-exam" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname === "/quiz_section" &&
      link === "/quiz_section"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname === "/mocktest-analysis" &&
      link === "/mocktest-analysis"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/settings/employee-restrictions" &&
      link === "/settings/employee-restrictions"
    )
      return "collapse-item active";
    else return "collapse-item";
  };

  getActiveClassTwo = (link) => {
    const path = this.props.history.location.pathname;
    if (link === path) return "nav-link active";
    // Expense module uses tab sub-routes (/expense-management/:tab e.g. categories, approvals)
    else if (
      link === "/expense-management" &&
      path.startsWith("/expense-management")
    )
      return "nav-link active";
    // School Activity Management uses tab sub-routes (/school-activity-management/:tab)
    else if (
      link === "/school-activity-management" &&
      path.startsWith("/school-activity-management")
    )
      return "nav-link active";
    // Communication Management uses tab sub-routes (/communication-management/:tab)
    else if (
      link === "/communication-management" &&
      path.startsWith("/communication-management")
    )
      return "nav-link active";
    // Video Classes uses tab sub-routes (/lecture-library/:tab e.g. manage, upload, masters)
    else if (
      link === "/lecture-library" &&
      path.startsWith("/lecture-library")
    )
      return "nav-link active";
    // Certificate Generation uses tab sub-routes (/Certificate-Generation/:tab e.g. history, create, templates, builder)
    else if (
      link === "/Certificate-Generation" &&
      path.toLowerCase().startsWith("/certificate-generation")
    )
      return "nav-link active";
    // Exams uses tab sub-routes (/Offline_Examiantions/:tab e.g. create-class-subjects)
    else if (
      link === "/Offline_Examiantions" &&
      path.toLowerCase().startsWith("/offline_examiantions")
    )
      return "nav-link active";
    // Library uses sub-routes /library/:tab
    else if (
      link === "/library" &&
      path.startsWith("/library")
    )
      return "nav-link active";
    else return "nav-link";
  };

  toggleSection = (key) => {
    this.setState((prev) => {
      const isOpen = !!prev.openSections[key];
      if (isOpen) {
        // Clicking an open section always collapses it (even the active one).
        return { openSections: { ...prev.openSections, [key]: false } };
      }
      // open clicked section; close all others
      return { openSections: { [key]: true } };
    });
  };

  componentDidMount = () => {
    if (this.scrollRef.current) {
      this.scrollRef.current.addEventListener(
        "scroll",
        this.handleScrollTrack,
        { passive: true },
      );
    }
    // Pinned-open sidebar doesn't fire mouseenter, so restore scroll here
    if (this.isPinnedOpen()) {
      const saved = parseInt(sessionStorage.getItem(SCROLL_KEY) || "0", 10);
      requestAnimationFrame(() => {
        if (this.scrollRef.current) this.scrollRef.current.scrollTop = saved;
      });
    }
  };

  componentWillUnmount = () => {
    if (this.scrollRef.current) {
      this.scrollRef.current.removeEventListener(
        "scroll",
        this.handleScrollTrack,
      );
    }
  };

  render() {
    // ── OLD CODE (kept for reference / rollback) ─────────────────────────────
    // Read the legacy moduleRestrictions blob straight from localStorage, so the
    // menu reflected whatever login happened to write there rather than the role's
    // actual is_view grants.
    //
    // let moduleRestrictions = "";
    //
    // if (
    //   JSON.parse(localStorage.getItem("moduleRestrictions")) != undefined &&
    //   JSON.parse(localStorage.getItem("moduleRestrictions")) != ""
    // ) {
    //   moduleRestrictions = JSON.parse(
    //     localStorage.getItem("moduleRestrictions"),
    //   );
    // }
    //
    // console.log("moduleRestrictions", moduleRestrictions);
    //
    // console.log("toggled", Cookies.get("toggle"));

    // ── NEW CODE ─────────────────────────────────────────────────────────────
    // Derive visibility from the role's is_view grants (roleModuleAccess). Same
    // { module_key: false } shape, so all ~90 gates below work unchanged — but a
    // module now appears only when the backend actually granted view on it.
    const moduleRestrictions = buildModuleVisibility();

    return (
      <div
        className=""
        onMouseEnter={this.handleSidebarEnter}
        onMouseLeave={this.handleSidebarLeave}
      >
        <div className="sidebar-header mb-0 px-2 py-2">
          <div className="mt-4-res mt-3">
            {/* Institute logo from the `url` cookie (set at login); Rizee logo removed. */}
            <Link className="brand-logo" to="/dashboard">
              {/* Full institute logo — shown only when the sidebar is expanded */}
              {Cookies.get("url") ? (
                <Image src={Cookies.get("url")} alt="LOGO" className="brand-logo-full" style={{ width: "100%", maxWidth: 220, maxHeight: 50, height: "auto", objectFit: "contain" }} />
              ) : null}
              {/* Compact logo — shown only when the sidebar is collapsed (icon-only mode) */}
              <Image
                src={
                  String(Cookies.get("institutionid")) === "119"
                    ? vignanShortLogo
                    : Cookies.get("url") || vignanShortLogo
                }
                alt="LOGO"
                className="brand-logo-short"
              />
            </Link>
          </div>

          <div className="sidebar-scroll" ref={this.scrollRef}>
            <Nav className="navbar-nav menu mt-2 mb-2">
              <React.Fragment>
                {/* {Array.from({ length: 15 }).map((_, index) => (
                        <div key={index}>

                          <div className="d-flex align-items-center mb-2">
                       
                            <div
                              style={{
                                width: "18px",
                                height: "18px",
                                background: "#e0e0e0",
                                borderRadius: "4px",
                                marginRight: "10px"
                              }}
                            ></div>

                         
                            <div
                              style={{
                                width: "100%",
                                height: "10px",
                                background: "#e0e0e0",
                                borderRadius: "4px"
                              }}
                            ></div>
                          </div>

               
                          <div className="w-100 border-bottom mb-3 opacity-25"></div>
                        </div>
                    */}

                <React.Fragment>
                  <div className="hr_new mb-2"></div>
                  {moduleRestrictions.Dashboard != undefined &&
                    moduleRestrictions.Dashboard == false ? (
                    <Nav.Item>
                      <Link className={this.getActiveClassTwo("/dashboard")} to="/dashboard">
                        <i className="fas fa-fw fa-tachometer-alt"></i>{" "}
                        <span>Dashboard</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {moduleRestrictions.Management_Report != undefined &&
                    moduleRestrictions.Management_Report == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/management-mis-reports")}
                        to="/management-mis-reports"
                      >
                        <i className="fas fa-fw fa-chart-line mr-2"></i>{" "}
                        <span>Management Report</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {/* {moduleRestrictions.OMR_Results != undefined &&
                  moduleRestrictions.OMR_Results == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/omr-results")}
                        to="/omr-results"
                      >
                        <i className="fas fa-fw fa-scanner-image mr-2"></i>{" "}
                        <span>OMR Results</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )} */}

                  {/* Upload Results — separate OMR upload module */}
                  {/* {moduleRestrictions.OMR_Results != undefined &&
                  moduleRestrictions.OMR_Results == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/omr-upload")}
                        to="/omr-upload"
                      >
                        <i className="fas fa-fw fa-cloud-upload mr-2"></i>{" "}
                        <span>Upload Results</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )} */}

                  {/* Student Doubts — gated on the Student_Doubts module-access key
                      (sidebar link + /student-doubts route guard). Hidden when the
                      role has no is_view grant for the key. */}
                  {moduleRestrictions.Student_Doubts != undefined &&
                    moduleRestrictions.Student_Doubts == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/student-doubts")}
                        to="/student-doubts"
                      >
                        <i className="fas fa-fw fa-comments"></i>{" "}
                        <span>Student Doubts</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {/* HR Management sidebar entry — commented out per request.
                      The module (its /hr-management routes and components) stays in
                      the codebase; only this sidebar link is hidden. Uncomment this
                      block to re-enable the dropdown.
                  <Nav.Item>
                    <Nav.Link
                      active={false}
                      onClick={() => this.toggleSection(20)}
                      aria-expanded={!!this.state.openSections[20]}
                    >
                      <i className="fas fa-fw fa-user-tie"></i>{" "}
                      <span>HR Management</span>
                      <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                    </Nav.Link>
                    <Collapse in={!!this.state.openSections[20]}>
                      <div className="collapse-inner rounded">
                        {[
                          { label: "Dashboard", to: "/hr-management/dashboard", icon: "fas fa-tachometer-alt" },
                          { label: "Employee Management", to: "/hr-management/employees", icon: "fas fa-users" },
                          { label: "Departments & Designations", to: "/hr-management/departments", icon: "fas fa-sitemap" },
                          { label: "Attendance", to: "/hr-management/attendance", icon: "fas fa-clipboard-check" },
                          { label: "Lecturer Time Table", to: "/hr-management/timetable", icon: "fas fa-calendar-alt" },
                          { label: "Leave Management", to: "/hr-management/leave", icon: "fas fa-plane-departure" },
                          { label: "Payroll", to: "/hr-management/payroll", icon: "fas fa-wallet" },
                          { label: "Performance", to: "/hr-management/performance", icon: "fas fa-award" },
                          { label: "Recruitment & Onboarding", to: "/hr-management/recruitment", icon: "fas fa-user-plus" },
                          { label: "Employee Documents", to: "/hr-management/documents", icon: "fas fa-folder-open" },
                          { label: "Self-Service (ESS)", to: "/hr-management/ess", icon: "fas fa-id-badge" },
                          { label: "Reports & Analytics", to: "/hr-management/reports", icon: "fas fa-chart-bar" },
                          { label: "Exit Management", to: "/hr-management/exit", icon: "fas fa-sign-out-alt" },
                        ].map((item) => (
                          <Nav.Item key={item.to}>
                            <Link
                              className={
                                this.props.history.location.pathname === item.to
                                  ? "collapse-item active"
                                  : "collapse-item"
                              }
                              to={item.to}
                            >
                              <i
                                className={`${item.icon} ml-1 mr-2`}
                                style={{ color: "#F8C52C", fontSize: "14px", width: 15 }}
                              ></i>
                              {item.label}
                            </Link>
                          </Nav.Item>
                        ))}
                      </div>
                    </Collapse>
                  </Nav.Item>
                  */}

                  {(moduleRestrictions.Exam_Made_Easy == false ||
                    moduleRestrictions.Manage_Exams == false ||
                    moduleRestrictions.Quiz == false ||
                    moduleRestrictions.View_Results == false ||
                    moduleRestrictions.academic_students == false) &&
                    !undefined ? (
                    <div className="mt-2 w-100 mb-1 group_type">
                      <h6>ACADEMICS</h6>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* Online Exams */}
                  {(moduleRestrictions.Exam_Made_Easy == false ||
                    moduleRestrictions.Manage_Exams == false ||
                    moduleRestrictions.Quiz == false ||
                    moduleRestrictions.View_Results == false) &&
                    !undefined ? (
                    <>
                      <Nav.Item>
                        <Nav.Link
                          active={false}
                          onClick={() => this.toggleSection(7)}
                          aria-expanded={!!this.state.openSections[7]}
                        >
                          <i className="fas fa-fw fa-file-alt"></i>{" "}
                          <span>Online Exams</span>
                          <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                        </Nav.Link>

                        <Collapse in={!!this.state.openSections[7]}>
                          <div className="collapse-inner rounded">
                            {moduleRestrictions.Exam_Made_Easy != undefined &&
                              moduleRestrictions.Exam_Made_Easy == false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/exam_made_easy",
                                    )}
                                    to="/exam_made_easy"
                                  >
                                    <i className="fas fa-fw fa-file-signature mr-2"></i>
                                    Exam Creation
                                  </Link>
                                </Nav.Item>
                              )}

                            {moduleRestrictions.Manage_Exams != undefined &&
                              moduleRestrictions.Manage_Exams == false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/questions/manage-question-paper",
                                    )}
                                    to="/questions/manage-question-paper"
                                  >
                                    <i className="fas fa-fw fa-file-contract mr-2"></i>
                                    Manage Exams
                                  </Link>
                                </Nav.Item>
                              )}

                            {moduleRestrictions.Quiz != undefined &&
                              moduleRestrictions.Quiz == false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/quiz_section",
                                    )}
                                    to="/quiz_section"
                                  >
                                    <i className="fas fa-fw fa-question-circle mr-2"></i>
                                    Quiz Creation
                                  </Link>
                                </Nav.Item>
                              )}

                            {moduleRestrictions.View_Results != undefined &&
                              moduleRestrictions.View_Results == false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/ExamReport_tabs",
                                    )}
                                    to="/ExamReport_tabs"
                                  >
                                    <i className="fas fa-fw fa-chart-bar mr-2"></i>
                                    Test Reports
                                  </Link>
                                </Nav.Item>
                              )}

                            {/* {
                                    moduleRestrictions.Send_notifications != undefined && moduleRestrictions.Send_notifications == false ?
                                      (
                                        <Nav.Item>
                                          <Link
                                            className={this.getActiveClass("/settings/adaptive-exams")}
                                            to="/settings/adaptive-exams"
                                          >
                                            <i className="fas fa-fw fa-brain mr-2"></i> <span>Adaptive fd</span>
                                          </Link>
                                        </Nav.Item>
                                      )
                                      :
                                      ("")
                                  } */}
                            {/* 
                            {moduleRestrictions.View_Results != undefined &&
                            moduleRestrictions.View_Results == false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass("/settings/overall-college-report")}
                                  to="/settings/overall-college-report"
                                >
                                  <i className="fas fa-fw fa-chart-bar mr-2 "></i> <span>Overall Report</span>
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )} */}

                            {/* {moduleRestrictions.Send_notifications !=
                              undefined &&
                            moduleRestrictions.Send_notifications == false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/settings/exam-paper-pdf/upload",
                                  )}
                                  to="/settings/exam-paper-pdf/upload"
                                >
                                  <i className="fas fa-fw fa-file-pdf mr-2"></i>{" "}
                                  <span>PDF Upload Report</span>
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )} */}
                          </div>
                        </Collapse>
                      </Nav.Item>
                    </>
                  ) : null}

                  {/* Offline(OMR) Exams — gated on its sub-module keys (OMR upload/history
                      use OMR_Results; the rest keep their own restriction keys). */}
                  {(moduleRestrictions.OMR_Results == false ||
                    moduleRestrictions.Exam_Made_Easy == false ||
                    moduleRestrictions.Manage_Exams == false ||
                    moduleRestrictions.View_Results == false) &&
                    !undefined ? (
                    <Nav.Item>
                      <Nav.Link
                        active={false}
                        onClick={() => this.toggleSection(8)}
                        aria-expanded={!!this.state.openSections[8]}
                      >
                        <i className="fas fa-fw fa-file-check"></i>{" "}
                        <span>Offline(OMR) Exams</span>
                        <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                      </Nav.Link>
                      <Collapse in={!!this.state.openSections[8]}>
                        <div className="collapse-inner rounded">
                          {[
                            {
                              key: "OMR_Results",
                              label: "Upload OMR",
                              to: "/offline_exams/omr/upload",
                              icon: ExamCreationImg,
                            },
                            {
                              key: "OMR_Results",
                              label: "History",
                              to: "/offline_exams/omr/history",
                              icon: ExamCreationImg,
                            },
                            {
                              key: "Exam_Made_Easy",
                              label: "Exam Creation",
                              to: "/offline_exams/exam_made_easy",
                              icon: ExamCreationImg,
                            },
                            {
                              key: "Manage_Exams",
                              label: "Scheduled Exams",
                              to: "/offline_exams/manage-question-paper",
                              icon: ManageExamsImg,
                            },
                            {
                              key: "View_Results",
                              label: "Exam Reports",
                              to: "/offline_exams/ExamReport",
                              icon: ExamReportsImg,
                            },
                          ]
                            .filter(
                              (item) =>
                                // Every link now obeys its own restriction key.
                                moduleRestrictions[item.key] != undefined &&
                                moduleRestrictions[item.key] == false,
                            )
                            .map((item, index) => (
                              <Nav.Item key={index}>
                                <Link
                                  className={this.getActiveClass(item.to)}
                                  to={item.to}
                                >
                                  <Image
                                    src={item.icon}
                                    className="ml-1 mr-3"
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />
                                  <span>{item.label}</span>
                                </Link>
                              </Nav.Item>
                            ))}
                        </div>
                      </Collapse>
                    </Nav.Item>
                  ) : null}

                  {/* Mock Test Analysis && Course Exams */}
                  {Cookies.get("institutionid") === 19 ? (
                    <>
                      <Nav.Item>
                        <Link
                          className={this.getActiveClassTwo(
                            "/lec_paper_generator",
                          )}
                          to="/lec_paper_generator"
                        >
                          <i className="fas fa-file-contract mr-2 mb-1 mt-1"></i>
                          <span>Mock Test Analysis</span>
                        </Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Link
                          className={this.getActiveClassTwo(
                            "/mocktest-analysis",
                          )}
                          to="/mocktest-analysis"
                        >
                          <i className="fas fa-file-alt mr-2 mb-1 mt-1"></i>
                          <span>Course Exams</span>
                        </Link>
                      </Nav.Item>
                    </>
                  ) : (
                    ""
                  )}

                  {(moduleRestrictions.admission_form == false ||
                    moduleRestrictions.admission_form_list == false ||
                    moduleRestrictions.Student_Attendance == false ||
                    moduleRestrictions.Student_Attendance_report == false ||
                    moduleRestrictions.offline_marks_uploading == false ||
                    moduleRestrictions.offline_marks_Results == false ||
                    moduleRestrictions.Fee_Structure == false ||
                    moduleRestrictions.Student_Attendance == false ||
                    moduleRestrictions.Student_Attendance == false ||
                    moduleRestrictions.Hostel_Buildings == false ||
                    moduleRestrictions.Permissions == false ||
                    moduleRestrictions.Hostel_Attendance ||
                    moduleRestrictions.Diary == false ||
                    moduleRestrictions.Hostel_Attendance_Report == false ||
                    moduleRestrictions.Material_Allocation == false ||
                    moduleRestrictions.Assignments == false ||
                    (moduleRestrictions.non_academic_students != undefined &&
                      moduleRestrictions.non_academic_students == false)) &&
                    !undefined ? (
                    <>
                      <div className="mt-2 w-100 mb-1 group_type">
                        <h6>ERP</h6>
                      </div>
                    </>
                  ) : null}

                  {(moduleRestrictions.admission_form_list == false ||
                    moduleRestrictions.admission_form == false ||
                    moduleRestrictions.Enquiry_management == false ||
                    moduleRestrictions.Lead_management == false) &&
                    !undefined ? (
                    <>
                      <Nav.Item>
                        <Link
                          className={
                            this.getAccordianActive() === 4
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/admissions-dashboard"
                        >
                          <i className="fas fa-fw fa-user-graduate mr-2"></i>
                          <span>Admissions</span>
                        </Link>
                      </Nav.Item>
                      {false && (
                        <Nav.Item>
                          <Nav.Link
                            active={false}
                            onClick={() => this.toggleSection(4)}
                            aria-expanded={!!this.state.openSections[4]}
                          >
                            <i className="fas fa-fw fa-user-graduate"></i>{" "}
                            <span>Admissions</span>
                            <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                          </Nav.Link>
                          <Collapse in={!!this.state.openSections[4]}>
                            <div className="collapse-inner rounded">
                              {moduleRestrictions.admission_dashboard !=
                                undefined &&
                                moduleRestrictions.admission_dashboard ==
                                false ? (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/admissions-dashboard",
                                    )}
                                    to="/admissions-dashboard"
                                  >
                                    <i
                                      className="fas fa-tachometer-alt ml-1 mr-3"
                                      style={{
                                        color: "#F8C52C",
                                        fontSize: "15px",
                                      }}
                                    ></i>
                                    Dashboard
                                  </Link>
                                </Nav.Item>
                              ) : moduleRestrictions.admission_dashboard ==
                                undefined ? (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/admissions-dashboard",
                                    )}
                                    to="/admissions-dashboard"
                                  >
                                    <i
                                      className="fas fa-tachometer-alt ml-1 mr-3"
                                      style={{
                                        color: "#F8C52C",
                                        fontSize: "15px",
                                      }}
                                    ></i>
                                    Admission Dashboard
                                  </Link>
                                </Nav.Item>
                              ) : (
                                ""
                              )}
                              {moduleRestrictions.admission_form != undefined &&
                                moduleRestrictions.admission_form == false ? (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/admission-forms/create",
                                    )}
                                    to="/admission-forms/create"
                                  >
                                    {/* <i className="fas fa-file-signature"></i>Admission Form */}
                                    <Image
                                      src={AdmissionFormImg}
                                      className="ml-1 mr-3"
                                      alt="New"
                                      width="15"
                                      height="15"
                                    />
                                    Create Enquiry Form
                                  </Link>
                                </Nav.Item>
                              ) : (
                                ""
                              )}
                              {moduleRestrictions.admission_form != undefined &&
                                moduleRestrictions.admission_form == false ? (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/create-admission-form",
                                    )}
                                    to="/create-admission-form"
                                  >
                                    {/* <i className="fas fa-file-signature"></i>Admission Form */}
                                    <Image
                                      src={AdmissionFormImg}
                                      className="ml-1 mr-3"
                                      alt="New"
                                      width="15"
                                      height="15"
                                    />
                                    Create / Edit Admission Form
                                  </Link>
                                </Nav.Item>
                              ) : (
                                ""
                              )}
                              {moduleRestrictions.admission_form != undefined &&
                                moduleRestrictions.admission_form == false ? (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/admission-forms",
                                    )}
                                    to="/admission-forms"
                                  >
                                    {/* <i className="fas fa-file-signature"></i>Admission Form */}
                                    <Image
                                      src={AdmissionFormImg}
                                      className="ml-1 mr-3"
                                      alt="New"
                                      width="15"
                                      height="15"
                                    />
                                    Manage Enquiry Forms
                                  </Link>
                                </Nav.Item>
                              ) : (
                                ""
                              )}

                              {/* {
                                moduleRestrictions.admission_form_list != undefined && moduleRestrictions.admission_form_list == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/student-admission-list")}
                                        to="/student-admission-list"
                                      >
                                        <i className="fas fa-file-signature"></i>Edmitted Students
                                        {/* <Image src={EnrolledStudentsImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Admitted Students */}

                              {/* </Link>
                                    </Nav.Item> 
                                  )
                                  :
                                  ("")
                              } */}

                              {/* {
                                moduleRestrictions.Enquiry_management != undefined && moduleRestrictions.Enquiry_management == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/enquiry-links")}
                                        to="/enquiry-links"
                                      >
                                        {/* <i class="fa fa-file" aria-hidden="true"></i>Enquiry links */}
                              {/* <Image src={EnquiryLinksImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Enquiry links
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              } */}
                              {moduleRestrictions.Lead_management !=
                                undefined &&
                                moduleRestrictions.Lead_management == false ? (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/message-center",
                                    )}
                                    to="/message-center"
                                  >
                                    <i className="fas fa-tasks mr-2"></i>
                                    <span>Messages</span>
                                  </Link>
                                </Nav.Item>
                              ) : (
                                ""
                              )}
                              {moduleRestrictions.Lead_management !=
                                undefined &&
                                moduleRestrictions.Lead_management == false ? (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/lead-management",
                                    )}
                                    to="/lead-management"
                                  >
                                    <i className="fas fa-tasks mr-2"></i>
                                    <span>Lead Management</span>
                                  </Link>
                                </Nav.Item>
                              ) : (
                                ""
                              )}
                            </div>
                          </Collapse>
                        </Nav.Item>
                      )}
                    </>
                  ) : null}
                  {(moduleRestrictions.Student_Attendance == false ||
                    moduleRestrictions.Student_Attendance_report == false ||
                    moduleRestrictions.Student_Attendance == false ||
                    moduleRestrictions.Student_Attendance == false ||
                    moduleRestrictions.Hostel_Attendance == false ||
                    moduleRestrictions.Hostel_Attendance_Report == false ||
                    moduleRestrictions.Biometric_Attendance == false) &&
                    !undefined ? (
                    <>
                      <Nav.Item>
                        <Nav.Link
                          active={false}
                          onClick={() => this.toggleSection(3)}
                          aria-expanded={!!this.state.openSections[3]}
                        >
                          <i className="fas fa-fw fa-clipboard-list"></i>{" "}
                          <span>Attendance</span>
                          <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                        </Nav.Link>
                        <Collapse in={!!this.state.openSections[3]}>
                          <div className="collapse-inner rounded">
                            {(moduleRestrictions.Student_Attendance_report !=
                              undefined &&
                              moduleRestrictions.Student_Attendance_report ==
                              false) ||
                              (moduleRestrictions.Student_Attendance !=
                                undefined &&
                                moduleRestrictions.Student_Attendance ==
                                false) ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/attendance-regularization",
                                  )}
                                  to="/attendance-regularization"
                                >
                                  <Image
                                    src={StudentAttendanceImg}
                                    className="ml-1 mr-1 "
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />
                                  Student Attendance
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )}

                            {moduleRestrictions.Student_Attendance !=
                              undefined &&
                              moduleRestrictions.Student_Attendance == false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/Employee_Attendance_Report",
                                  )}
                                  to="/Employee_Attendance_Report"
                                >
                                  {/* <i class="fa fa-file" aria-hidden="true"></i>Employee Attendance */}
                                  <Image
                                    src={EmpAttendanceImg}
                                    className="ml-1 mr-1 "
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />
                                  Employee Attendance
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )}
                            {(moduleRestrictions.Hostel_Attendance_Report !=
                              undefined &&
                              moduleRestrictions.Hostel_Attendance_Report ==
                              false) ||
                              (moduleRestrictions.Hostel_Attendance !=
                                undefined &&
                                moduleRestrictions.Hostel_Attendance == false) ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/hostel/attendance-report",
                                  )}
                                  to="/hostel/attendance-report"
                                >
                                  {/* <i class="fas fa-users"></i>Hostel Attendance */}
                                  <Image
                                    src={HostelAtnImp}
                                    className="ml-1 mr-1"
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />{" "}
                                  Hostel Attendance
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )}
                            {/* {moduleRestrictions.Biometric_Attendance !=
                              undefined &&
                              moduleRestrictions.Biometric_Attendance ==
                                false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/attendance-regularization",
                                  )}
                                  to="/attendance-regularization"
                                >
                                  <i
                                    className="fal fa-fingerprint ml-1 mr-2"
                                    style={{ fontSize: 14, width: 15 }}
                                  ></i>
                                  Biometric Attendance
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )} */}
                          </div>
                        </Collapse>
                      </Nav.Item>
                    </>
                  ) : null}
                  {/* <Nav.Item>
                    <Link
                      className={this.getActiveClassTwo(
                        "/communications-center",
                      )}
                      to="/communications-center"
                    >
                      <i className="fas fa-fw fa-comments-alt"></i>{" "}
                      <span>Communications Center</span>
                    </Link>
                  </Nav.Item> */}


                  {(moduleRestrictions.offline_marks_uploading == false ||
                    moduleRestrictions.offline_marks_Results == false) &&
                    !undefined ? (
                    <>
                      <Nav.Item>
                        <Nav.Link
                          onClick={() => this.toggleSection(6)}
                          aria-expanded={!!this.state.openSections[6]}
                        >
                          <i class="fas fa-fw fa-tasks"></i>{" "}
                          <span style={{}}>Offline Exams</span>
                          <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                        </Nav.Link>
                        <Collapse in={!!this.state.openSections[6]}>
                          <div className="collapse-inner rounded">
                            {moduleRestrictions.offline_marks_uploading !=
                              undefined &&
                              moduleRestrictions.offline_marks_uploading ==
                              false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/student/marks-upload",
                                  )}
                                  to="/student/marks-upload"
                                >

                                  <Image
                                    src={ExamMarkUploadImg}
                                    className="ml-1 mr-1"
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />
                                  Marks Uploading
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )}

                            {moduleRestrictions.offline_marks_Results !=
                              undefined &&
                              moduleRestrictions.offline_marks_Results ==
                              false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/student/offline-exam-results",
                                  )}
                                  to="/student/offline-exam-results"
                                >

                                  <Image
                                    src={ExamReportsImg}
                                    className="ml-1 mr-1"
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />
                                  Exam Report
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )}
                          </div>
                        </Collapse>
                      </Nav.Item>
                    </>
                  ) : null}

                  {(moduleRestrictions.Permissions == false ||
                    moduleRestrictions.Permission_pass == false) &&
                    !undefined ? (
                    <>
                      <Nav.Item>
                        <Nav.Link
                          active={false}
                          onClick={() => this.toggleSection(12)}
                          aria-expanded={!!this.state.openSections[12]}
                        >
                          <i class="fas fa-fw fa-user-check"></i>{" "}
                          <span style={{}}>Permissions</span>
                          <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                        </Nav.Link>

                        <Collapse in={!!this.state.openSections[12]}>
                          <div className="collapse-inner rounded">
                            {moduleRestrictions.Permissions != undefined &&
                              moduleRestrictions.Permissions == false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/student-permission",
                                  )}
                                  to="/student-permission"
                                >

                                  <Image
                                    src={PermissionsImg}
                                    className="ml-1 mr-3"
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />
                                  Permissions
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )}
                            {/* {moduleRestrictions.Permission_pass != undefined &&
                              moduleRestrictions.Permission_pass == false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/Student_Gate_Pass",
                                  )}
                                  to="/Student_Gate_Pass"
                                >
                                  
                                  <Image
                                    src={GatePassImg}
                                    className="ml-1 mr-3"
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />
                                  Gate Pass
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )} */}
                          </div>
                        </Collapse>
                      </Nav.Item>
                    </>
                  ) : null}

                  {/* MATERIALS */}
                  {/* <Nav.Item>
                    <Nav.Link
                      active={false}
                      onClick={() => this.toggleSection(9)}
                      aria-expanded={!!this.state.openSections[9]}
                    >
                      <i class="fas fa-fw fa-folder-open"></i>{" "}
                      <span>Materials</span>
                      <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                    </Nav.Link>

                    <Collapse in={!!this.state.openSections[9]}>
                      <div className="collapse-inner rounded">
                        {moduleRestrictions.Custom_Materials != undefined &&
                          moduleRestrictions.Custom_Materials == false ? (
                          <Nav.Item>
                            <Link
                              className={this.getActiveClass(
                                "/inst_revision_material",
                              )}
                              to="/inst_revision_material"
                            >
                              <i className="fas fa-fw fa-book-open mr-2"></i>{" "}
                              <span>Custom Materials</span>
                            </Link>
                          </Nav.Item>
                        ) : ""}

                        <Nav.Item>
                          <Link
                            className={this.getActiveClass(
                              "/material-assigning",
                            )}
                            to="/material-assigning"
                          >
                            <i className="fas fa-fw fa-box-open mr-2"></i>{" "}
                            <span>Material Allocation</span>
                          </Link>
                        </Nav.Item>
                      </div>
                    </Collapse>
                  </Nav.Item> */}

                  {moduleRestrictions.Offline_Examiantions != undefined &&
                    moduleRestrictions.Offline_Examiantions == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo(
                          "/Offline_Examiantions",
                        )}
                        to="/Offline_Examiantions"
                      >
                        <i className="fas fa-fw fa-tasks mr-2 mb-1 mt-1"></i>{" "}
                        <span>Exams</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {moduleRestrictions.Fee_Structure != undefined &&
                    moduleRestrictions.Fee_Structure == false ? (
                    <Nav.Item>
                      <Link
                        className={
                          this.props.history.location.pathname.startsWith(
                            "/Fee-Structure",
                          )
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/Fee-Structure/dashboard"
                      >
                        <i className="fas fa-fw fa-money-bill-wave mr-2 mb-1 mt-1"></i>{" "}
                        <span>Finance</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}
                  {moduleRestrictions.expense_management != undefined &&
                    moduleRestrictions.expense_management == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/expense-management")}
                        to="/expense-management"
                      >
                        <i className="fas fa-fw fa-receipt mr-2 mb-1 mt-1"></i>{" "}
                        <span>Expenses</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {/* Grievance Management — gated on the Grievance_Management module-access
                      key (sidebar link + /grievance-module route guard). */}
                  {moduleRestrictions.Grievance_Management != undefined &&
                    moduleRestrictions.Grievance_Management == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/grievance-module")}
                        to="/grievance-module"
                      >
                        <i className="fas fa-fw fa-comment-dots mr-2 mb-1 mt-1"></i>{" "}
                        <span>Grievance Management</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {moduleRestrictions.Accounts_Ledger != undefined &&
                    moduleRestrictions.Accounts_Ledger == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/accounts")}
                        to="/accounts"
                      >
                        <i className="fas fa-fw fa-book mr-2 mb-1 mt-1"></i>{" "}
                        <span>Accounts Ledger</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {/* <Nav.Item>
                    <Link
                      className={this.getActiveClassTwo("/library")}
                      to="/library"
                    >
                      <i className="fal fa-fw fa-book-reader mr-2 mb-1 mt-1"></i>{" "}
                      <span>Library</span>
                    </Link>
                  </Nav.Item> */}



                  {moduleRestrictions.Transport_Management != undefined &&
                    moduleRestrictions.Transport_Management == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo(
                          "/transport-management",
                        )}
                        to="/transport-management"
                      >
                        <i className="fas fa-fw fa-bus mr-2 mb-1 mt-1"></i>{" "}
                        <span>Transport</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {moduleRestrictions.School_Activity_Management != undefined &&
                    moduleRestrictions.School_Activity_Management == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo(
                          "/school-activity-management",
                        )}
                        to="/school-activity-management"
                      >
                        <i className="fas fa-fw fa-calendar-alt mr-2 mb-1 mt-1"></i>{" "}
                        <span>Events & Holidays</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {moduleRestrictions.communication_management != undefined &&
                    moduleRestrictions.communication_management == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo(
                          "/communication-management",
                        )}
                        to="/communication-management"
                      >
                        <i className="fas fa-fw fa-comments-alt mr-2 mb-1 mt-1"></i>{" "}
                        <span>Communication</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}
                  {moduleRestrictions.Communication_Management != undefined &&
                    moduleRestrictions.Communication_Management == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo(
                          "/communication-management",
                        )}
                        to="/communication-management"
                      >
                        <i className="fal fa-fw fa-comments-alt mr-2 mb-1 mt-1"></i>{" "}
                        <span>Communication Management</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {moduleRestrictions.Lecture_Library != undefined &&
                    moduleRestrictions.Lecture_Library == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/lecture-library")}
                        to="/lecture-library"
                      >
                        <i className="fas fa-fw fa-video mr-2 mb-1 mt-1"></i>{" "}
                        <span>Video Classes</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}
                  {moduleRestrictions.Document_Services != undefined &&
                    moduleRestrictions.Document_Services == false ? (
                    <Nav.Item>
                      <Link
                        className={
                          this.props.history.location.pathname.startsWith(
                            "/document-services",
                          )
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/document-services"
                      >
                        <i className="fas fa-fw fa-certificate mr-2 mb-1 mt-1"></i>{" "}
                        <span>Document</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {moduleRestrictions.Certificate_Generation != undefined &&
                    moduleRestrictions.Certificate_Generation == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo(
                          "/Certificate-Generation",
                        )}
                        to="/Certificate-Generation"
                      >
                        <i className="fas fa-fw fa-tasks mr-2 mb-1 mt-1"></i>{" "}
                        <span>Certificate</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}
                  {moduleRestrictions.Certificate != undefined &&
                    moduleRestrictions.Certificate == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo(
                          "/Certificate-Generation",
                        )}
                        to="/Certificate-Generation"
                      >
                        <i className="fal fa-fw fa-tasks mr-2 mb-1 mt-1"></i>{" "}
                        <span>Certificate</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {/* <Nav.Item>
                    <Link
                      className={this.getActiveClassTwo(
                        "/Certificate-Generation",
                      )}
                      to="/Certificate-Generation"
                    >
                      <i className="fas fa-fw fa-file-certificate mr-2 mb-1 mt-1"></i>{" "}
                      <span>Certificate Generation</span>
                    </Link>

                  </Nav.Item> */}

                  {((moduleRestrictions.academic_planner != undefined &&
                    moduleRestrictions.academic_planner == false) ||
                    (moduleRestrictions.timetable_builder != undefined &&
                      moduleRestrictions.timetable_builder == false) ||
                    isFullAccess()) ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/academic-planner")}
                        to="/academic-planner"
                      >
                        <i className="fas fa-fw fa-calendar-check mr-2 mt-1 mb-1"></i>{" "}
                        <span>Academic Planner</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {moduleRestrictions.timetable_builder != undefined &&
                    moduleRestrictions.timetable_builder == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo(
                          "/timetable-builder",
                        )}
                        to="/timetable-builder"
                      >
                        <i className="fas fa-fw fa-calendar-alt mr-2 mt-1 mb-1"></i>{" "}
                        <span>Time Table</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {(moduleRestrictions.Diary == false ||
                    moduleRestrictions.Assignments == false) &&
                    !undefined ? (
                    <>
                      <Nav.Item>
                        <Nav.Link
                          active={false}
                          onClick={() => this.toggleSection(5)}
                          aria-expanded={!!this.state.openSections[5]}
                        >
                          <i class="fas fa-fw fa-book"></i>{" "}
                          <span style={{}}>Diary & Asgmt</span>
                          <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                        </Nav.Link>
                        <Collapse in={!!this.state.openSections[5]}>
                          <div className="collapse-inner rounded">
                            {moduleRestrictions.Diary != undefined &&
                              moduleRestrictions.Diary == false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/student-diary",
                                  )}
                                  to="/student-diary"
                                >
                                  {/* <i className="fas fa-file-signature"></i>Diary */}
                                  <Image
                                    src={DiaryImg}
                                    className="ml-1 mr-3"
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />
                                  Diary
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )}

                            {moduleRestrictions.Assignments != undefined &&
                              moduleRestrictions.Assignments == false ? (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass("/assignment")}
                                  to="/assignment/dashboard"
                                >
                                  {/* <i class="fas fa-users"></i>Assignments */}
                                  <Image
                                    src={AssignmentsImg}
                                    className="ml-1 mr-3"
                                    alt="New"
                                    width="15"
                                    height="15"
                                  />
                                  Assignments
                                </Link>
                              </Nav.Item>
                            ) : (
                              ""
                            )}
                          </div>
                        </Collapse>
                      </Nav.Item>
                    </>
                  ) : null}

                  {/* Notification group (Notify Parents / Notify Students) — hidden.
                  {((moduleRestrictions.parent_notifications != undefined &&
                    moduleRestrictions.parent_notifications == false) ||
                    (moduleRestrictions.Send_notifications != undefined &&
                      moduleRestrictions.Send_notifications == false)) && (
                      <>
                        <Nav.Item>
                          <Nav.Link
                            active={false}
                            onClick={() => this.toggleSection(11)}
                            aria-expanded={!!this.state.openSections[11]}
                          >
                            <i class="fas fa-fw fa-bell"></i>{" "}
                            <span>Notification</span>
                            <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                          </Nav.Link>

                          <Collapse in={!!this.state.openSections[11]}>
                            <div className="collapse-inner rounded">
                              {moduleRestrictions.parent_notifications !=
                                undefined &&
                                moduleRestrictions.parent_notifications ==
                                  false ? (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/Parent_Notification",
                                    )}
                                    to="/Parent_Notification"
                                  >
                                    <i className="fas fa-fw fa-bell-school mr-2"></i>{" "}
                                    <span>Notify Parents</span>
                                  </Link>
                                </Nav.Item>
                              ) : (
                                ""
                              )}

                              {moduleRestrictions.Send_notifications !=
                                undefined &&
                                moduleRestrictions.Send_notifications ==
                                  false ? (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/settings/notify-students",
                                    )}
                                    to="/settings/notify-students"
                                  >
                                    <i className="fas fa-fw fa-users mr-2"></i>{" "}
                                    <span>Notify Students</span>
                                  </Link>
                                </Nav.Item>
                              ) : (
                                ""
                              )}
                            </div>
                          </Collapse>
                        </Nav.Item>
                      </>
                    )}
                  */}

                  {moduleRestrictions.Hostel_Buildings != undefined &&
                    moduleRestrictions.Hostel_Buildings == false ? (
                    <Nav.Item>
                      <Link
                        className={this.getActiveClassTwo("/building-creation")}
                        to="/building-creation"
                      >
                        <i className="fas fa-fw fa-building mr-2 mb-1 mt-1"></i>{" "}
                        <span>Building Creation</span>
                      </Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}

                  {/* Only show the group header when at least one module under it
                      (Students or Settings) is accessible — otherwise the yellow
                      heading appeared with nothing beneath it. */}
                  {(moduleRestrictions.academic_students === false ||
                    moduleRestrictions.non_academic_students === false ||
                    moduleRestrictions.Employee_Restrctions == false ||
                    moduleRestrictions.branches == false ||
                    moduleRestrictions.sections == false ||
                    moduleRestrictions.organization_profile == false ||
                    moduleRestrictions.Settings == false) ? (
                    <div className="mt-2 w-100 mb-1 group_type">
                      <h6>SETTINGS &amp; MORE</h6>
                    </div>
                  ) : null}

                  {(moduleRestrictions.academic_students === false ||
                    moduleRestrictions.non_academic_students === false) ? (
                    <>
                      <Nav.Item>
                        <Nav.Link
                          active={false}
                          onClick={() => this.toggleSection(10)}
                          aria-expanded={!!this.state.openSections[10]}
                        >
                          <i className="fas fa-fw fa-users"></i> <span>Students</span>
                          <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                        </Nav.Link>

                        <Collapse in={!!this.state.openSections[10]}>
                          <div className="collapse-inner rounded">
                            {moduleRestrictions.academic_students === false && (
                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass(
                                    "/settings/students",
                                  )}
                                  to="/settings/students"
                                >
                                  <i className="fas fa-book-reader"></i>{" "}
                                  <span>Academic Students</span>
                                </Link>
                              </Nav.Item>
                            )}

                            {moduleRestrictions.non_academic_students ===
                              false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass(
                                      "/settings/non-academic-students",
                                    )}
                                    to="/settings/non-academic-students"
                                  >
                                    <i className="fas fa-fw fa-user-graduate"></i>{" "}
                                    <span>Students</span>
                                  </Link>
                                </Nav.Item>
                              )}
                          </div>
                        </Collapse>
                      </Nav.Item>
                    </>
                  ) : null}

                  {/* Settings — show the section when ANY child module is granted,
                      the same way the other grouped sections behave (no dedicated
                      `Settings` key needed). */}
                  {(moduleRestrictions.Employee_Restrctions == false ||
                    moduleRestrictions.branches == false ||
                    moduleRestrictions.sections == false ||
                    moduleRestrictions.organization_profile == false ||
                    moduleRestrictions.Settings == false) &&
                    !undefined ? (
                    <Nav.Item>
                      <Nav.Link
                        active={false}
                        onClick={() => this.toggleSection(2)}
                        aria-expanded={!!this.state.openSections[2]}
                      >
                        <i className="fas fa-fw fa-cogs mr-2"></i>{" "}
                        <span>Settings</span>
                        <i className="nav-arrow" style={{ marginLeft: "auto", display: "inline-block", color: "#f8c52c" }}>▼</i>
                      </Nav.Link>
                      <Collapse in={!!this.state.openSections[2]}>
                        <div className="collapse-inner rounded">
                          {/* {moduleRestrictions.user_creation != undefined &&
                            moduleRestrictions.user_creation == false ? (
                            <Link
                              className={this.getActiveClass(
                                "/settings/user-creations",
                              )}
                              to="/settings/user-creations"
                            >
                              <i className="fas fa-user" /> User Creations
                            </Link>
                          ) : (
                            ""
                          )} */}

                          {moduleRestrictions.Employee_Restrctions !=
                            undefined &&
                            moduleRestrictions.Employee_Restrctions == false ? (
                            <Link
                              className={this.getActiveClass(
                                "/settings/staff",
                              )}
                              to="/settings/staff"
                            >
                              <i className="fas fa-book-reader" /> Staff
                            </Link>
                          ) : (
                            ""
                          )}

                          {/* {moduleRestrictions.package != undefined &&
                            moduleRestrictions.package == false ? (
                            <Link
                              className={this.getActiveClass(
                                "/settings/package",
                              )}
                              to="/settings/package"
                            >
                              <i className="fas fa-box" /> Package
                            </Link>
                          ) : (
                            ""
                          )} */}

                          {/* {moduleRestrictions.categories != undefined &&
                            moduleRestrictions.categories == false ? (
                            <Link
                              className={this.getActiveClass(
                                "/settings/category",
                              )}
                              to="/settings/category"
                            >
                              <i className="fas fa-album-collection" />{" "}
                              Categories
                            </Link>
                          ) : (
                            ""
                          )} */}

                          {moduleRestrictions.branches != undefined &&
                            moduleRestrictions.branches == false ? (
                            <Link
                              className={this.getActiveClass(
                                "/settings/branches",
                              )}
                              to="/settings/branches"
                            >
                              <i className="fas fa-fw fa-building" /> Branches
                            </Link>
                          ) : (
                            ""
                          )}

                          {moduleRestrictions.branches != undefined &&
                            moduleRestrictions.branches == false ? (
                            <Link
                              className={this.getActiveClass(
                                "/settings/branch-classes",
                              )}
                              to="/settings/branch-classes"
                            >
                              <i className="fas fa-chalkboard" /> Classes
                            </Link>
                          ) : (
                            ""
                          )}

                          {moduleRestrictions.sections != undefined &&
                            moduleRestrictions.sections == false ? (
                            <Link
                              className={this.getActiveClass(
                                "/settings/sections",
                              )}
                              to="/settings/sections"
                            >
                              <i className="fas fa-layer-group" /> Section
                            </Link>
                          ) : (
                            ""
                          )}

                          {moduleRestrictions.organization_profile !=
                            undefined &&
                            moduleRestrictions.organization_profile == false ? (
                            <Link
                              className={this.getActiveClass(
                                "/settings/organization-profile",
                              )}
                              to="/settings/organization-profile"
                            >
                              <i className="fas fa-container-storage" />{" "}
                              Organization Profile
                            </Link>
                          ) : (
                            ""
                          )}

                          {/* {moduleRestrictions.groups != undefined &&
                            moduleRestrictions.groups == false ? (
                            <Link
                              className={this.getActiveClass(
                                "/settings/groups",
                              )}
                              to="/settings/groups"
                            >
                              <i className="fas fa-users" /> Groups
                            </Link>
                          ) : (
                            ""
                          )} */}
                        </div>
                      </Collapse>
                    </Nav.Item>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              </React.Fragment>
            </Nav>
          </div>

          <a
            href="https://rizee.in/"
            target="_blank"
            className="powered-by-footer text-decoration-none d-block"
          >
            <p className="product_brand text-center mb-0">
              <span className="powered_text">Powered by </span>
              <span className="product_brand_sub">Rizee</span>
            </p>
          </a>
        </div>
      </div>
    );
  }
}
export default withRouter(SideNavbar);
